import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { TSelectProps } from '../../components/select';
import { LayoutContext } from '../../contexts/layout';
import { formFieldsSelector } from '../../redux/selectors/forms';
import { ISelectOption } from '../../types/components/select';
import useRest from '../useRest';
import dataJSON from './data.json';
import { setFormFieldData, setFormFieldValue } from '../../redux/actions/forms';

const useSelect = ({
    dataLink, data: predefinedData, dependingFields, dataIndex, value,
}: TSelectProps) => {
    const { layoutId } = useContext(LayoutContext);

    const [data, setData] = useState<ISelectOption[]>(predefinedData || []);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const dependingFieldsValues = useSelector(formFieldsSelector(layoutId, dependingFields));

    const rest = useRest();

    const { objectId } = useParams();

    const updateLink = (link: string) => {
        if (typeof objectId === 'string') {
            return link.replace('{objectId}', objectId);
        }
        return link;
    };

    const hasValueOptionInData = (newData: ISelectOption[]) => {
        if (typeof value === 'string' || typeof value === 'number') {
            return newData.filter((el) => el.value === value).length > 0;
        }
        if (Array.isArray(value) && value.length > 0) {
            return newData.filter((el) => value.includes(el.value)).length > 0;
        }
        return false;
    };

    const getData = async () => {
        if (typeof dataLink === 'string') {
            setLoading(true);

            const result = await rest.fetch({
                objectName: updateLink(dataLink),
                method: 'post',
                data: dependingFieldsValues,
            });

            if (!result.isError && result.response?.data && typeof result.response.data.totalCount === 'number' && Array.isArray(result.response.data.data)) {
                setData(result.response.data.data);
                dispatch(setFormFieldData(layoutId, dataIndex, result.response.data.data));
                if (!hasValueOptionInData(result.response.data.data)) {
                    dispatch(setFormFieldValue(layoutId, dataIndex, null));
                }
            } else {
                // @ts-ignore
                setData(dataJSON);
            }

            setLoading(false);
        }
    };

    useEffect(() => {
        if (Object.keys(dependingFieldsValues).length > 0) {
            getData();
        }
    }, [Object.values(dependingFieldsValues).join(',')]);

    return {
        data,
        loading,
    };
};

export default useSelect;
